import axiosInstance from "../utils/axios";

export const summaryForBoard = async({description})=>{
    try {
        const response = await axiosInstance.post('/api/board-page',({description}));
        
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const summaryForTeam = async({description, instructionText})=>{
    try {
        const response = await axiosInstance.post('/api/team-page',({description, instructionText}));
        
        return response.data || {};
    } catch (error) {
        throw error;
    }
}

export const getSummaryForBoard = async () => {
    try {
        const response = await axiosInstance.get('/api/board-page');
        return response.data || {};
    } catch (error) {
        throw error;
    }
};

export const getSummaryForTeam = async () => {
    try {
        const response = await axiosInstance.get('/api/team-page');
        return response.data || {};
    } catch (error) {
        throw error;
    }
};


export const getPageHeader = async () => {
    try {
        const response = await axiosInstance.get('/api/page-settings/page-headers');
        return response.data || {};
    } catch (error) {
        throw error;
    }
}

export const updatePageHeader = async (key, h1, tagline, content) => {
    try {
        const response = await axiosInstance.put(`/api/page-settings/page-headers/${key}`, { h1, tagline, content });
        return response.data || {};
    } catch (error) {
        throw error;
    }
}

export const getPageHeaderByKey = async (key) => {
    try {
        const response = await axiosInstance.get(`/api/page-settings/page-headers/${key}`);
        return response.data || {};
    } catch (error) {
        throw error;
    }
}